import { faBook, faChessBoard, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { Box, DialogContent, Divider, Stack, Tab } from "@mui/material";
import Button from "@mui/material/Button";

import { Icon } from "@/components/ui-v2/Icon/Icon";
import { Tabs } from "@/components/ui-v2/Tabs/Tabs";

import { usePoserStore } from "../../state";
import { PoseLibraryTab } from "../../types";
import { LibraryPoses } from "./components/LibraryPoses/LibraryPoses";
import { WorkspacePoses } from "./components/WorkspacePoses/WorkspacePoses";

interface PosePickerProps {
  workspaceId: string;
  workspaceName: string;
}

export const PosePicker = (props: PosePickerProps) => {
  const { workspaceName, workspaceId } = props;

  const { selectTab, selectedTab, openPoseCreatorInCreateMode } =
    usePoserStore();

  const handleTabSelect = (
    _event: React.SyntheticEvent,
    value: PoseLibraryTab,
  ) => {
    selectTab(value);
  };

  const handlePoseCreate = () => {
    openPoseCreatorInCreateMode();
  };

  return (
    <Stack sx={{ height: "100%", display: "flex" }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          py: 1,
          flexShrink: 0,
        }}
      >
        <Tabs size="large" value={selectedTab} onChange={handleTabSelect}>
          <Tab
            label={
              <Stack
                spacing={2}
                direction="row"
                sx={{
                  alignItems: "center",
                }}
              >
                <Icon icon={faBook} />
                <Box>Pose library</Box>
              </Stack>
            }
            value="library"
          />
          <Tab
            label={
              <Stack
                spacing={2}
                direction="row"
                sx={{
                  alignItems: "center",
                }}
              >
                <Icon icon={faChessBoard} />
                <Box>Workspace poses</Box>
              </Stack>
            }
            value="workspace"
          />
        </Tabs>
        <Stack direction="row" spacing={1}>
          <Button
            variant="text"
            color="primary"
            startIcon={<Icon size="medium" icon={faPlus} />}
            onClick={handlePoseCreate}
          >
            Create Pose
          </Button>
        </Stack>
      </Stack>
      <Divider sx={{ flexShrink: 0 }} />
      <DialogContent sx={{ p: 2, flex: 1, overflow: "auto" }}>
        {selectedTab === "workspace" && (
          <WorkspacePoses
            workspaceName={workspaceName}
            workspaceId={workspaceId}
          />
        )}
        {selectedTab === "library" && <LibraryPoses />}
      </DialogContent>
    </Stack>
  );
};
